module.exports = __webpack_public_path__ + "img/programme2.04727fde.png";